export const photoUpload = (setFilesToAttach, filesToUpload, setErrorContent, setIsSystemError) => {
    // A removed preview also leaves the upload list (it used to stay there and upload anyway).
    // Previews carry their File, because FileReader can finish out of order and the two
    // lists' indexes do not always line up.
    const removeFile = (index) => {
        setFilesToAttach(filesToAttach => {
            const removed = filesToAttach[index];
            if (removed?.file) {
                const uploadIndex = filesToUpload.findIndex(f => f.image === removed.file);
                if (uploadIndex !== -1) filesToUpload.splice(uploadIndex, 1);
            }
            return filesToAttach.filter((file, i) => i !== index);
        });
    };

    const addFileToDisplay = async (image, file) => {
        if (image != "") {
            let imagesW = {
                'image': "",
                'fileType': "",
                'file': file
            };
            imagesW.image = image;
            imagesW.fileType = file.type;
            setFilesToAttach(filesToAttach => [...filesToAttach, imagesW]);
        }
    };

    const addFileToUpload = (file) => {
        if (file != "") {
            var imagesW = {
                'image': "",
                'fileType': ""
            };
            imagesW.image = file;
            imagesW.fileType = file.type;
            filesToUpload.push(imagesW);
        }
    };

    const handleFileAttachment = (e) => {
        if (e.target.files.length == 0)
            return;
        let files = e.target.files;
        if (files.length === 0) {
            return;
        } else {
            for (let file of files) {
                if (file.size > 10485760) {
                    setErrorContent({ 'header': "File size exceeded", 'body': "Please try again with a file size less than 10MB." });
                    setIsSystemError(true);
                    return;
                }
                addFileToUpload(file);
                var reader = new FileReader();
                reader.onload = async (e) => {
                    await addFileToDisplay(e.target.result, file);
                };
                reader.readAsDataURL(file);
            }
        };
    };
    return { removeFile, handleFileAttachment };
}

